import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Bluetooth = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Bluetooth' {...props}>
    <polyline fill='none' stroke='#000' strokeWidth='2' points='7 7 17 16 12 20 12 4 17 8 7 16' />
  </StyledIcon>
);
